import Action from '@/assets/action.svg'
import actionComplete from '@/assets/actionComplete.svg'
import actionWhite from '@/assets/actionWhite.svg'
import warning from '@/assets/warning.svg'
import warningWhite from '@/assets/warningWhite.svg'
import Chip from '@/components/Atoms/Chip'
import { IActionItem, IAlertItem } from '@/components/survey/SurveyModel/types/nodeTypes'
import { RootState } from '@/reducers/store'
import { useUpdateAccordionSection } from '@/state/survey/poaSurveySlice'
import Utility from '@/utils/Utility'
import { memo } from 'react'
import { useSelector } from 'react-redux'

interface AlertsProps {
    alerts?: IAlertItem[]
    actions?: IActionItem[]
}

const Alerts: React.FC<AlertsProps> = memo(({ alerts = [], actions = [] }) => {
    const { questionnaireDetails } = useSelector((state: RootState) => state.poaSurvey)
    const updateAccordionSection = useUpdateAccordionSection()

    /**
     * Uses setTimeout with 0ms delay to defer the scroll operation to the next tick
     * of the event loop. This ensures that any pending DOM updates or layout changes
     * are completed before attempting to scroll, preventing issues where the target
     * element might not be in its final position or might not exist yet in the DOM.
     */
    const scrollToElement = (section: string) => {
        setTimeout(() => {
            const element = document.getElementById(section)
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
            }
        }, 0);
    };

    const handleClick = (section: string) => {
        // Find the parent section of the node
        const parentSection = Utility.findParentSection(section, questionnaireDetails?.nodes || []);
        
        // If we found a parent section, expand the accordion
        if (parentSection) {
            updateAccordionSection(parentSection, true);
        }
        
        scrollToElement(section);
    }

    return (
        <div className="alerts-bar-wrap ">
            <div className="alerts-wrap flex flex-wrap justify-start">
                {alerts.map((alert, index) => (
                    <Chip
                        key={index}
                        section={alert.nodeName}
                        onClick={handleClick}
                        label={alert.label}
                        style={'alert alert-red'}
                        icon={warning}
                        iconWhite={warningWhite}
                    />
                ))}
                {actions.filter(a => a.type).map((action, index) => (
                    <Chip
                        key={index}
                        section={action.nodeName}
                        label={action.name}
                        onClick={handleClick}
                        style={'alert alert-blue'}
                        icon={action.type ? Action : actionComplete}
                        iconWhite={action.type ? actionWhite : actionComplete}
                    />
                ))}
            </div>
        </div>
    )
})

export default Alerts
